import React, {lazy, Suspense} from "react";
import {Route, Routes} from "react-router-dom";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import ProtectedRoute from "@/app/routes/ProtectedRoute";
import Home from "@/app/features/home";
import ChatsPage from "@/app/features/chats/widget";
import FindPlayersPage from "@/app/features/find_players/widget";
import DetailPlayerPage from "@/app/features/find_players/pages/detail_player_page/widget";
import MapPage from "@/app/features/map/widget";
import EmailsInWhiteList from "@/app/features/emailsInWhiteList";
import Profile from "@/app/features/profile";
import CreateAMatchPage from "@/app/features/create_a_match/widget";
import NotificationsPage from "@/app/features/notifications/widget";
import MatchesPage from "@/app/features/matches/widget";
import InvitationPage from "@/app/features/invitation_detail/widget";
import MatchDetailPage from "@/app/features/match_detail";
import CourtVerification from "@/app/features/court_verification_page/widget";
import TermsOfService from "@/app/features/terms_of_service/widget";
import PrivacyPolicy from "@/app/features/privacy_policy/widget";

const SignUpPage = lazy(() => import("@/app/features/signup"));
const OnboardingPage = lazy(() => import("@/app/features/onboarding"));
const ChangePassword = lazy(() => import("@/app/features/changePassword"));

const AppRoutes: React.FC = () => {

  return (
    <Suspense fallback={<CircularProgressIndicator/>}>
      <Routes>
        <Route path={route.signup} element={<SignUpPage/>}/>
        <Route path={route.changePassword} element={<ChangePassword/>}/>
        <Route path={route.termsOfService} element={<TermsOfService/>}/>
        <Route path={route.privacyPolicy} element={<PrivacyPolicy/>}/>
        <Route element={<ProtectedRoute/>}>
          <Route path={route.emailsInWhiteList} element={<EmailsInWhiteList/>}/>
          <Route path={route.courtVerificationPage} element={<CourtVerification/>}/>
          <Route path={route.home} element={<Home/>}/>
          <Route path={route.chats} element={<ChatsPage/>}/>
          <Route path={route.findPlayers} element={<FindPlayersPage/>}>
            <Route path={route.detailPlayer} element={<DetailPlayerPage/>}/>
          </Route>
          <Route path={route.maps} element={<MapPage/>}/>
          <Route path={route.matches} element={<MatchesPage/>}/>
          <Route path={route.invitationPage} element={<InvitationPage/>}/>
          <Route path={route.matchDetailPage} element={<MatchDetailPage/>}/>
          <Route path={route.notifications} element={<NotificationsPage/>}/>
          <Route path={route.profile} element={<Profile/>}/>
          <Route path={route.createAMatch} element={<CreateAMatchPage/>}/>
          <Route path={route.onboarding} element={<OnboardingPage/>}/>
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;

export class route {
  static home = "/";
  static signup = "/signup";
  static onboarding = "/onboarding";
  static changePassword = "/changePassword";
  static chats = "/chats";
  static findPlayers = "/findPlayers";
  static detailPlayer = "detailPlayer";
  static maps = "/map";
  static profile = "/profile";
  static emailsInWhiteList = "/emailsInWhiteList";
  static courtVerificationPage = "/courtVerificationPage";
  static createAMatch = "/createAMatch";
  static notifications = "/notifications";
  static matches = "/matches";
  static invitationPage = "/invitationPage";
  static matchDetailPage = "/matchDetailPage";
  static termsOfService = "/terms-of-service";
  static privacyPolicy = "/privacy-policy";
}